<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="goToHomeConnectUser()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Add Login Details
            </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="requestFormGroup">
            <div class="row">
                <div class="col-sm-12 col-md-12 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Role</mat-label>
                        <mat-select class="scrollbarcs" formControlName="roleId"
                            (selectionChange)="onRoleChange($event)" placeholder="Please select Role">
                            <mat-select-filter [displayMember]="'value'" [array]="filterRoleList"
                                (filteredReturn)="roleList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of roleList" [value]="item.key"
                                style="overflow-y: scroll !important;">
                                {{item.value}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- <div class="col-sm-12 col-md-12  mt-4">
                    <span class="radio_label">Select Title</span>
                    <mat-radio-group aria-label="Select an option" class="col-md-12 col-lg-12 col-sm-12 pl-0"
                        formControlName="title">
                        <mat-radio-button *ngFor="let data of title" [value]="data.key">
                            <span class="mr-2">{{data.value}}</span>
                        </mat-radio-button>
                        <div class="text-danger" *ngIf="!requestFormGroup.get('title').valid && (requestFormGroup.get('title').dirty
                            || requestFormGroup.get('title').touched)">
                            <div>
                                Please Select Title
                            </div>
                        </div>
                    </mat-radio-group>
                </div> -->

                <div class="col-sm-12 col-md-12 mt-3" *ngIf="!requestFormGroup.get('roleId')?.value">
                    <span style="color: red;">*Note : Please select a role first to proceed with the remaining
                        fields.*</span>
                </div>

                <div class="col-sm-12 col-md-6 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>First Name</mat-label>
                        <input matInput appInputtext maxlength="25" formControlName="firstName"
                            placeholder="Enter First Name" required class="col-12" autocomplete="off"
                            (keydown.space)="preventLeadingSpace($event)">
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Last Name</mat-label>
                        <input matInput appInputtext formControlName="lastName" maxlength="25"
                            placeholder="Enter Last Name" required (keydown.space)="preventLeadingSpace($event)"
                            class="col-12" autocomplete="off">
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>
                            {{ showCompanyRegistrationNumber
                            ? 'ID / Passport Number / Company Registration Number'
                            : 'ID / Passport Number' }}
                        </mat-label> <input matInput formControlName="identificationNumber" maxlength="20"
                            (input)="fillcontent()" placeholder="Enter ID / Passport Number" class="col-12"
                            autocomplete="off">
                    </mat-form-field>
                </div>

                <!-- <div class="col-sm-12 col-md-6 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>ID / Passport Number</mat-label>
                        <input matInput formControlName="identificationNumber" maxlength="13" (input)="fillcontent()"
                            placeholder="Enter ID / Passport Number" class="col-12" autocomplete="off">
                    </mat-form-field>
                </div> -->
                <!-- <div class="col-sm-12 col-md-6 mt-4 form-radio-group mobile">
                    <mat-radio-group class="mat-radio-group tp-radio-button ng-untouched ng-pristine ng-invalid mt-0"
                        formControlName="gender" hideRequiredMarker>
                        <mat-label ngClass="form-text">Gender</mat-label>
                        <mat-radio-button class="button-color" value="male">Male</mat-radio-button>
                        <mat-radio-button value="female" style="margin-left:8px;">Female</mat-radio-button>
                    </mat-radio-group>
                    <div class="text-danger" *ngIf="!requestFormGroup.get('gender').valid && (requestFormGroup.get('gender').dirty
                    || requestFormGroup.get('gender').touched)">
                        <div>
                            Please Select Gender
                        </div>
                    </div>
                </div> -->

                <div class="col-sm-12 col-md-6 mt-4 date_picker">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Date of Birth</mat-label>
                        <input readonly matInput [matDatepicker]="dateOfBirth" id="dateOfBirth"
                            formControlName="dateOfBirth" autocomplete="off" placeholder="Enter Date of Birth"
                            [min]="minDate" [max]="maxDate" class="col-12" class="custom-input-border"
                            specialIsAlphaNumeric required (click)="openDatePicker()">
                        <span class="" style="position: absolute;right: 3%;top: -2%;">
                            <i class="far fa-calendar-alt" (click)="openDatePicker()" style="color: #690194;"></i>
                        </span>
                        <mat-datepicker #dateOfBirth></mat-datepicker>
                    </mat-form-field>
                </div>


                <div class="col-sm-12 col-md-6 mt-4 " style="display: flex;">
                    <div class="css27">
                        <mat-form-field appearance="fill" hideRequiredMarker style="width: 60px !important;">
                            <mat-label>+27</mat-label>
                            <input readonly class="form-control" matInput maxlength="10" type="text"
                                id="mobileNumberLabel" placeholder="+27" formControlName="mobileNumberLabel"
                                autocomplete="off" class="col-12">
                        </mat-form-field>
                    </div>
                    <div class="css272" style="width: 100%;">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Contact Number</mat-label>
                            <input class="form-control" matInput maxlength="9" type="text" id="mobileNumber"
                                placeholder="Enter Contact Number" formControlName="mobileNumber" autocomplete="off"
                                (keypress)="onlyNumbers($event)" class="col-12">
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" placeholder="Enter Email Address" required
                            class="col-12"
                            pattern="^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,15})$"
                            autocomplete="off" (keydown.space)="preventLeadingSpace($event)">
                    </mat-form-field>
                </div>

                <!-- <div class="col-sm-12 col-md-6 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Role</mat-label>
                        <mat-select class="scrollbarcs" formControlName="roleId"
                            (selectionChange)="onRoleChange($event)" placeholder="Please select Role">
                            <mat-select-filter [displayMember]="'value'" [array]="filterRoleList"
                                (filteredReturn)="roleList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of roleList" [value]="item.key"
                                style="overflow-y: scroll !important;">
                                {{item.value}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div> -->

                <div class="col-sm-12 col-md-6 mt-4" *ngIf="showReseller">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Reseller</mat-label>
                        <mat-select class="scrollbarcs" formControlName="resellerCode"
                            placeholder="Please select Reseller">
                            <mat-select-filter [displayMember]="'value'" [array]="filterResellerList"
                                (filteredReturn)="resellerList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of resellerList" [value]="item.key"
                                style="overflow-y: scroll !important;">
                                {{item.value}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 mt-4" *ngIf="showResellerCustomer && !isReachCheckBoxShow">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Reseller Group</mat-label>
                        <input matInput maxlength="25" formControlName="resellerGroup"
                            placeholder="Enter Reseller Group" class="col-10" autocomplete="off"
                            (keydown.space)="preventLeadingSpace($event)">
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 mt-4" *ngIf="showResellerCustomer && !isReachCheckBoxShow">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Customer Code</mat-label>
                        <input matInput maxlength="25" formControlName="customerCode" placeholder="Enter Customer code"
                            class="col-10" autocomplete="off" (keydown.space)="preventLeadingSpace($event)"
                            (input)="restrictSpecialChars($event)">
                    </mat-form-field>
                </div>

                <!-- <div class=" col-sm-12 col-md-6 mt-4" *ngIf="showResellerCustomer && isReachChecked">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Prepaid Customer Code</mat-label>
                        <input matInput maxlength="25" formControlName="reachCustomerCode"
                            placeholder="Enter Reseller Customer code" class="col-10" autocomplete="off"
                            (keydown.space)="preventLeadingSpace($event)" (input)="restrictSpecialChars($event)">
                    </mat-form-field>
                </div> -->

                <div class=" col-sm-12 col-md-12 mt-4" *ngIf="isReachCheckBoxShow">
                    <div class="col-12" style="margin-left: -8px;">
                        <mat-checkbox style="transform: scale(1.3);" color="primary" [checked]="isReachChecked"
                            (change)="CheckboxReach($event)" formControlName="isReachAddOrUpdate"></mat-checkbox>
                        <label style="margin-left:12px; font-size: large; white-space: nowrap;">
                            {{paramsid ===0 ?
                            'Include this user in Prepaid Portal?': 'Update this user in Prepaid Portal?'}}
                        </label>
                    </div>
                </div>

                <div class="col-sm-12 col-md-12  mt-1" style="font-size: 17px;" *ngIf="isUserAddedToReach">
                    <strong style="color:red;">Note:</strong>
                    <strong style="margin-left: 8px;">This user has been added to both portals.</strong>
                </div>

            </div>
            <div class="d-flex justify-content-center button-style">
                <button class="btn btn-secondary mb-3 mt-5" (click)="onsubmit()" matButton>
                    <i class="fa fa-user mr-2"></i> {{paramsid ===0 ?'Create Login': 'Update'}}</button>
            </div>
        </form>
    </div>
</div>